import api from 'services/api.service';

export type PagbankAccountStatus = {
  enabled: boolean;
  /** Abrir conta e Connect liberados; sem isso só dá para informar o ACCO. */
  canCreate: boolean;
  account: {
    accoId: string;
    status: 'PENDING_KYC' | 'ACTIVE' | 'INACTIVE';
    source: 'CREATED' | 'CONNECT' | 'MANUAL';
    canReceiveSplit: boolean;
    pendingKyc: boolean;
  } | null;
};

export type PagbankAddress = {
  street: string;
  number: string;
  complement?: string;
  locality: string;
  city: string;
  regionCode: string;
  postalCode: string;
};

export type PagbankPhone = { country: string; area: string; number: string };

export type CreateSubaccountPayload = {
  email: string;
  businessCategory: string;
  /** Dono da conta — ou um sócio, quando há `company`. Sempre pessoa física. */
  person: {
    name: string;
    birthDate: string;
    motherName: string;
    taxId: string;
    phone: PagbankPhone;
    address: PagbankAddress;
  };
  /**
   * Só para PJ. Telefone e endereço são opcionais na PagSeguro, e não há nome
   * fantasia: ela exige trade_name nulo em conta SELLER.
   */
  company?: {
    name: string;
    taxId: string;
    phone?: PagbankPhone;
    address?: PagbankAddress;
  };
};

export type PrefillParty = {
  name: string | null;
  taxId: string | null;
  phone: { area: string; number: string } | null;
  address: (Omit<PagbankAddress, 'complement'> & { complement: string | null }) | null;
};

export type SubaccountPrefill = {
  /** PJ quando o documento do lojista é CNPJ — aí `person` vem vazia. */
  personType: 'PF' | 'PJ';
  email: string | null;
  company: PrefillParty | null;
  person: PrefillParty;
  missing: string[];
};

export const getSubaccountPrefill = () =>
  api.get<SubaccountPrefill>('me/pagbank-account/prefill').then((res) => res.data);

export type BusinessCategory = { value: string; label: string };

/** A lista vem do backend para não divergir do que o DTO aceita. */
export const listBusinessCategories = () =>
  api
    .get<BusinessCategory[]>('me/pagbank-account/business-categories')
    .then((res) => res.data);

export const getPagbankAccount = () =>
  api.get<PagbankAccountStatus>('me/pagbank-account').then((res) => res.data);

export const createPagbankSubaccount = (payload: CreateSubaccountPayload) =>
  api.post('me/pagbank-account', payload).then((res) => res.data);

export const getPagbankConnectUrl = (returnUrl?: string) =>
  api
    .get<{ url: string }>('me/pagbank-account/connect-url', {
      params: returnUrl ? { returnUrl } : undefined,
    })
    .then((res) => res.data);

export const bindPagbankAccount = (accoId: string) =>
  api.post('me/pagbank-account/bind', { accoId }).then((res) => res.data);

export const revalidatePagbankAccount = () =>
  api.post('me/pagbank-account/revalidate').then((res) => res.data);
